import React, { useMemo } from 'react';
import InputComponent from '@ui/components/Input/Input.component';
import ModalComponent from '@ui/components/Modal/Modal.component';
import ButtonComponent from '@ui/components/Button/Button.component';
import ButtonBarComponent from '@ui/components/Button-bar/Button-bar.component';
import LinkComponent from '@ui/components/Link/Link.component';
import ModalFormComponent from '@ui/components/Modal-form/Modal-form.component';
import { IProps } from './IProps';
import { Box } from '@mui/material';

const Component: React.FC<IProps> = ({
    loading,
    authError,
    lang,
    login,
    password,
    loginError,
    passwordError,
    registerError,
    serverError,
    onBtnKeyDown,
    onInputClick,
    onLoginChange,
    onPasswordChange,
    onSignInClick,
    onRegisterOpen,
    onPassRecoveryOpen,
    onKeyDown,
    onClose,
}: IProps) => {
    const alertMessage = useMemo(() => {
        if (authError) return 'authError';
        else if (registerError) return 'registerError';
        else if (serverError) return 'serverError';
        else return '';
    }, [authError, registerError, serverError]);    
    return (
        <ModalComponent
            className="authenticationOld"
            title="authenticationOld"
            alertText={alertMessage}
            lang={lang}
            loading={loading}
            onBtnKeyDown={onBtnKeyDown}
            onClose={onClose}
        >
            <ModalFormComponent>
                <InputComponent
                    label="login"
                    name="login"
                    type="text"
                    errorMessage="inputLogin"
                    lang={lang}
                    value={login}
                    error={loginError}
                    onChange={onLoginChange}
                    onClick={onInputClick}
                    onFocus={onInputClick}
                    onKeyDown={onKeyDown}
                />
                <InputComponent
                    label="password"
                    name="password"
                    type="password"
                    errorMessage="passwordAlertMessage"
                    lang={lang}
                    value={password}
                    error={passwordError}
                    onChange={onPasswordChange}
                    onClick={onInputClick}
                    onFocus={onInputClick}
                    onKeyDown={onKeyDown}
                />
                <Box className="modal__links">
                    
                    <LinkComponent
                        text="recoverThePassword"
                        lang={lang}
                        onClick={onPassRecoveryOpen}
                        onKeyDown={onBtnKeyDown}
                    />
                </Box>
            </ModalFormComponent>
            <ButtonBarComponent>
                <ButtonComponent
                    label="signIn"
                    lang={lang}
                    onClick={onSignInClick}
                    onKeyDown={onBtnKeyDown}
                />
            </ButtonBarComponent>
        </ModalComponent>
    );
};

const LoginComponent = React.memo(Component);

export default LoginComponent;
